import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Index from "../views/Index.vue";
const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "index",
        component: Index,
        redirect: '/home',
        children: [
            {
                path: "/home", // 欢迎页
                name: "home",
                component: () => import("../views/Home.vue"),
            },
            {
                path: "/street/index", // 街道列表
                name: "streetIndex",
                component: () => import("../views/street/Index.vue"),
            },
            {
                path: "/street/edit", // 街道编辑
                name: "streetEdit",
                component: () => import("../views/street/Edit.vue"),
            },
            {
                path: "/street/add", // 添加产业集群
                name: "add",
                component: () => import("../views/street/Add.vue"),
            },
            {
                path: "/street/industryPolicy/index", // 街道-产业政策列表
                name: "industryPolicyIndex",
                component: () => import("../views/street/industry-policy/Index.vue"),
            },
            {
                path: "/street/industryPolicy/edit", // 街道-产业政策编辑
                name: "industryPolicyEdit",
                component: () => import("../views/street/industry-policy/Edit.vue"),
            },
            {
                path: "/street/convergenceMedia/index", // 街道-融媒体列表
                name: "convergenceMediaIndex",
                component: () => import("../views/street/convergence-media/Index.vue"),
            },
            {
                path: "/street/convergenceMedia/edit", // 街道-融媒体编辑
                name: "convergenceMediaEdit",
                component: () => import("../views/street/convergence-media/Edit.vue"),
            },
            {
                path: "/investor/index", // 投资机构列表
                name: "investorIndex",
                component: () => import("../views/investor/Index.vue"),
            },
            {
                path: "/investor/edit", // 投资机构编辑
                name: "investorEdit",
                component: () => import("../views/investor/Edit.vue"),
            },
            {
                path: "/investor/businessPlan/index", // 投资机构-商业计划书列表
                name: "investorBusinessPlanIndex",
                component: () => import("../views/investor/business-plan/Index.vue"),
            },
            {
                path: "/investor/businessPlan/detail", // 投资机构-商业计划书详情
                name: "investorBusinessPlanDetail",
                component: () => import("../views/investor/business-plan/Detail.vue"),
            },
            {
                path: "/study/index", // 院校列表
                name: "studyIndex",
                component: () => import("../views/study/Index.vue"),
            },
            {
                path: "/study/edit", // 院校编辑
                name: "studyEdit",
                component: () => import("../views/study/Edit.vue"),
            },
            {
                path: "/study/expert/index", // 院校-专家列表
                name: "studyExpertIndex",
                component: () => import("../views/study/expert/Index.vue"),
            },
            {
                path: "/study/expert/edit", // 院校-专家编辑
                name: "studyExpertEdit",
                component: () => import("../views/study/expert/Edit.vue"),
            },
            {
                path: "/study/laboratory/index", // 院校-实验室列表
                name: "studyLaboratoryIndex",
                component: () => import("../views/study/laboratory/Index.vue"),
            },
            {
                path: "/study/laboratory/edit", // 院校-实验室编辑
                name: "studyLaboratoryEdit",
                component: () => import("../views/study/laboratory/Edit.vue"),
            },
            {
                path: "/study/achievement/index", // 院校-实验室列表
                name: "studyAchievementIndex",
                component: () => import("../views/study/achievement/Index.vue"),
            },
            {
                path: "/study/achievement/edit", // 院校-实验室编辑
                name: "studyAchievementEdit",
                component: () => import("../views/study/achievement/Edit.vue"),
            },
            {
                path: "/study/publication/index", // 院校-出版物列表
                name: "studyPublicationIndex",
                component: () => import("../views/study/publication/Index.vue"),
            },
            {
                path: "/study/publication/edit", // 院校-出版物编辑
                name: "studyPublicationEdit",
                component: () => import("../views/study/publication/Edit.vue"),
            },
            {
                path: "/study-meeting/index", // 院校-活动列表
                name: "studyMeetingIndex",
                component: () => import("../views/study/meeting/Index.vue"),
            },
            {
                path: "/study/meeting/edit", // 院校-活动编辑
                name: "studyMeetingEdit",
                component: () => import("../views/study/meeting/Edit.vue"),
            },
            {
                path: "/association/index", // 协会列表
                name: "associationIndex",
                component: () => import("../views/association/Index.vue"),
            },
            {
                path: "/association/edit", // 协会编辑
                name: "associationEdit",
                component: () => import("../views/association/Edit.vue"),
            },
            {
                path: "/association/leader/index", // 协会-领导列表
                name: "associationLeaderIndex",
                component: () => import("../views/association/leaders/Index.vue"),
            },
            {
                path: "/association-leaders/index", // 协会-领导列表
                name: "userAssociationLeaderIndex",
                component: () => import("../views/association/leaders/Index.vue"),
            },
            {
                path: "/association/leader/edit", // 协会-领导编辑
                name: "associationLeaderEdit",
                component: () => import("../views/association/leaders/Edit.vue"),
            },
            {
                path: "/association/dynamic/index", // 协会-动态列表
                name: "associationDynamicIndex",
                component: () => import("../views/association/dynamic/Index.vue"),
            },
            {
                path: "/association-dynamic/index", // 协会-动态列表
                name: "userAssociationDynamicIndex",
                component: () => import("../views/association/dynamic/Index.vue"),
            },
            {
                path: "/association/dynamic/edit", // 协会-动态编辑
                name: "associationDynamicEdit",
                component: () => import("../views/association/dynamic/Edit.vue"),
            },
            {
                path: "/association/industryDynamic/index", // 协会-产业动态列表
                name: "industryDynamicIndex",
                component: () => import("../views/association/industry-dynamic/Index.vue"),
            },
            {
                path: "/association-industry-dynamic/index", // 协会-产业动态列表
                name: "userIndustryDynamicIndex",
                component: () => import("../views/association/industry-dynamic/Index.vue"),
            },
            {
                path: "/association/industryDynamic/edit", // 协会-产业动态编辑
                name: "industryDynamicEdit",
                component: () => import("../views/association/industry-dynamic/Edit.vue"),
            },
            {
                path: "/association/member/index", // 协会-会员列表
                name: "associationMemberIndex",
                component: () => import("../views/association/member/Index.vue"),
            },
            {
                path: "/association-publication/index", // 协会-会员列表
                name: "userAssociationMemberIndex",
                component: () => import("../views/association/member/Index.vue"),
            },
            {
                path: "/association/member/edit", // 协会-会员编辑
                name: "associationMemberEdit",
                component: () => import("../views/association/member/Edit.vue"),
            },
            {
                path: "/bank/index", // 分行列表
                name: "bankIndex",
                component: () => import("../views/bank/Index.vue"),
            },
            {
                path: "/bank/edit", // 分行编辑
                name: "bankEdit",
                component: () => import("../views/bank/Edit.vue"),
            },
            {
                path: "/bank/branchBank/index", // 支行列表
                name: "branchBankIndex",
                component: () => import("../views/bank/branch-bank/Index.vue"),
            },
            {
                path: "/bank-branch/index", // 支行列表
                name: "userBranchBankIndex",
                redirect: "/bank/branchBank/index",
                component: () => import("../views/bank/branch-bank/Index.vue"),
            },
            {
                path: "/bank/branchBank/edit", // 支行编辑
                name: "branchBankEdit",
                component: () => import("../views/bank/branch-bank/Edit.vue"),
            },
            {
                path: "/operator/index", // 运营商列表
                name: "operatorIndex",
                component: () => import("../views/operator/Index.vue"),
            },
            {
                path: "/operator/edit", // 运营商编辑
                name: "operatorEdit",
                component: () => import("../views/operator/Edit.vue"),
            },
            {
                path: "/service-provider/index", // 服务商列表
                name: "serviceProviderIndex",
                component: () => import("../views/service-provider/Index.vue"),
            },
            {
                path: "/service-provider/edit", // 服务商编辑
                name: "serviceProviderEdit",
                component: () => import("../views/service-provider/Edit.vue"),
            },
            {
                path: "/garden/index", // 园区列表
                name: "gardenIndex",
                component: () => import("../views/garden/Index.vue"),
            },
            {
                path: "/garden/edit", // 园区编辑
                name: "gardenEdit",
                component: () => import("../views/garden/Edit.vue"),
            },
            {
                path: "/garden/policy/index", // 园区-招商政策列表
                name: "gardenPolicyIndex",
                component: () => import("../views/garden/policy/Index.vue"),
            },
            {
                path: "/garden-zheng-ce/index", // 园区-招商政策列表
                name: "userGardenPolicyIndex",
                redirect: "/garden/policy/index",
                component: () => import("../views/garden/policy/Index.vue"),
            },
            {
                path: "/garden/policy/edit", // 园区-招商政策编辑
                name: "gardenPolicyEdit",
                component: () => import("../views/garden/policy/Edit.vue"),
            },
            {
                path: "/garden/news/index", // 园区-园区动态列表
                name: "gardenNewsIndex",
                component: () => import("../views/garden/news/Index.vue"),
            },
            {
                path: "/garden-news/index", // 园区-园区动态列表
                name: "userGardenNewsIndex",
                redirect: "/garden/news/index",
                component: () => import("../views/garden/news/Index.vue"),
            },
            {
                path: "/garden/news/edit", // 园区-园区动态编辑
                name: "gardenNewsEdit",
                component: () => import("../views/garden/news/Edit.vue"),
            },
            {
                path: "/message-post/index", // 园区-产业定制列表
                name: "messagePostIndex",
                component: () => import("../views/garden/message-post/Index.vue"),
            },
            {
                path: "/message-post/edit", // 园区-产业定制编辑
                name: "messagePostEdit",
                component: () => import("../views/garden/message-post/Edit.vue"),
            },
            {
                path: "/company/index", // 企业列表
                name: "companyIndex",
                component: () => import("../views/company/Index.vue"),
            },
            {
                path: "/company/edit", // 企业编辑
                name: "companyEdit",
                component: () => import("../views/company/Edit.vue"),
            },
            {
                path: "/company/shareholder/index", // 企业-股东列表
                name: "shareholderIndex",
                component: () => import("../views/company/shareholder/Index.vue"),
            },
            {
                path: "/company-gu-dong-group-member/index", // 企业-股东列表
                name: "userShareholderIndex",
                redirect: "/company/shareholder/index",
                component: () => import("../views/company/shareholder/Index.vue"),
            },
            {
                path: "/company/shareholder/edit", // 企业-股东编辑
                name: "shareholderEdit",
                component: () => import("../views/company/shareholder/Edit.vue"),
            },
            {
                path: "/company/senior/index", // 企业-高管列表
                name: "seniorIndex",
                component: () => import("../views/company/senior/Index.vue"),
            },
            {
                path: "/company-manage-member/index", // 企业-高管列表
                name: "userSeniorIndex",
                redirect: "/company/senior/index",
                component: () => import("../views/company/senior/Index.vue"),
            },
            {
                path: "/company/senior/edit", // 企业-高管编辑
                name: "seniorEdit",
                component: () => import("../views/company/senior/Edit.vue"),
            },
            {
                path: "/company/financialStatement/index", // 企业-财务指标列表
                name: "financialStatementIndex",
                component: () => import("../views/company/financial-statement/Index.vue"),
            },
            {
                path: "/company-cai-wu-zhi-biao/index", // 企业-财务指标列表
                name: "userFinancialStatementIndex",
                redirect: "/company/financialStatement/index",
                component: () => import("../views/company/financial-statement/Index.vue"),
            },
            {
                path: "/company/financialStatement/edit", // 企业-财务指标编辑
                name: "financialStatementEdit",
                component: () => import("../views/company/financial-statement/Edit.vue"),
            },
            {
                path: "/company/financialReport/index", // 企业-财务报告列表
                name: "financialReportIndex",
                component: () => import("../views/company/financial-report/Index.vue"),
            },
            {
                path: "/company-cai-wu-bao-gao/index", // 企业-财务报告列表
                name: "userFinancialReportIndex",
                redirect: "/company/financialReport/index",
                component: () => import("../views/company/financial-report/Index.vue"),
            },
            {
                path: "/company/notice/index", // 企业-相关公告列表
                name: "companyNoticeIndex",
                component: () => import("../views/company/notice/Index.vue"),
            },
            {
                path: "/affiche/index", // 企业-相关公告列表
                name: "afficheIndex",
                redirect: "/company/notice/index",
                component: () => import("../views/company/notice/Index.vue"),
            },
            {
                path: "/company/notice/edit", // 企业-相关公告编辑
                name: "companyNoticeEdit",
                component: () => import("../views/company/notice/Edit.vue"),
            },
            {
                path: "/collective-type-original/index", // 全部产业集群列表
                name: "collectiveTypeIndex",
                component: () => import("../views/collective-type/Index.vue"),
            },
            {
                path: "/industrial-chain/index", // 全部产业链分类列表
                name: "industrialChainIndex",
                component: () => import("../views/industrial-chain/Index.vue"),
            },
            {
                path: "/collective-type-group/index", // 产业集群-编组列表
                name: "collectiveGroupIndex",
                component: () => import("../views/collective-type/GroupIndex.vue"),
            },
            {
                path: "/industrial-chain-group/index", // 产业链分类-编组列表
                name: "industrialChainGroupIndex",
                component: () => import("../views/industrial-chain/GroupIndex.vue"),
            },
            {
                path: "/committee/index", // 产业集群-专家委员会列表
                name: "committeeIndex",
                component: () => import("../views/collective-type/committee/Index.vue"),
            },
            {
                path: "/committee/edit", // 产业集群-专家委员会编辑
                name: "committeeEdit",
                component: () => import("../views/collective-type/committee/Edit.vue"),
            },
            {
                path: "/research/index", // 产业集群-产业研究列表
                name: "researchIndex",
                component: () => import("../views/collective-type/research/Index.vue"),
            },
            {
                path: "/research/edit", // 产业集群-产业研究编辑
                name: "researchEdit",
                component: () => import("../views/collective-type/research/Edit.vue"),
            },
            {
                path: "/information/index", // 通知文章列表
                name: "informationIndex",
                component: () => import("../views/information/Index.vue"),
            },
            {
                path: "/information/edit", // 通知文章编辑
                name: "informationEdit",
                component: () => import("../views/information/Edit.vue"),
            },
            {
                path: "/hatching/index", // 孵化成果列表
                name: "hatchingIndex",
                component: () => import("../views/hatching/Index.vue"),
            },
            {
                path: "/hatching/edit", // 孵化成果编辑
                name: "hatchingEdit",
                component: () => import("../views/hatching/Edit.vue"),
            },
            {
                path: "/laws/index", // 法律法规列表
                name: "lawsIndex",
                component: () => import("../views/laws/Index.vue"),
            },
            {
                path: "/laws/edit", // 法律法规编辑
                name: "lawsEdit",
                component: () => import("../views/laws/Edit.vue"),
            },
            {
                path: "/rule/index", // 红筹规则列表
                name: "ruleIndex",
                component: () => import("../views/rule/Index.vue"),
            },
            {
                path: "/rule/edit", // 红筹规则编辑
                name: "ruleEdit",
                component: () => import("../views/rule/Edit.vue"),
            },
            {
                path: "/articles/index", // 文章总库列表
                name: "articlesIndex",
                component: () => import("../views/articles/Index.vue"),
            },
            {
                path: "/articles/edit", // 文章总库编辑
                name: "articlesEdit",
                component: () => import("../views/articles/Edit.vue"),
            },
            {
                path: "/articles/push/index", // 文章总库列表-发布列表
                name: "articlesPushIndex",
                component: () => import("../views/articles/push-articles/Index.vue"),
            },
            {
                path: "/articles-cate/index", // 文章总库列表-发布列表
                name: "articlesCateIndex",
                component: () => import("../views/articles/push-articles/Index.vue"),
            },
            {
                path: "/articles/push/edit", // 文章总库编辑-发布列表
                name: "articlesPushEdit",
                component: () => import("../views/articles/push-articles/Edit.vue"),
            },
            {
                path: "/financing-order/index", // 融资信息列表（办理，审核，小程序）
                name: "financingOrderIndex",
                component: () => import("../views/financing/order/Index.vue"),
            },
            {
                path: "/financing-order/edit", // 融资信息-办理
                name: "financingOrderEdit",
                component: () => import("../views/financing/order/Edit.vue"),
            },
            {
                path: "/financing-order-handle/index", // 融资信息-银行/服务商办理列表
                name: "financingHandleIndex",
                component: () => import("../views/financing/handle/Index.vue"),
            },
            {
                path: "/financing-order-handle/edit", // 融资信息-银行/服务商办理详情
                name: "financingHandleEdit",
                component: () => import("../views/financing/handle/Edit.vue"),
            },
            {
                path: "/financing-information-record/index", // 融资信息-p2ipo客户列表
                name: "financingInformationIndex",
                component: () => import("../views/financing/information/Index.vue"),
            },
            {
                path: "/financing-information-record/edit", // 融资信息-p2ipo客户详情
                name: "financingInformationEdit",
                component: () => import("../views/financing/information/Edit.vue"),
            },
            {
                path: "/financing-order-matter/index", // 融资信息-授信评估列表
                name: "financingMatterIndex",
                component: () => import("../views/financing/matter/Index.vue"),
            },
            {
                path: "/financing-order-matter/edit", // 融资信息-授信评估详情
                name: "financingMatterEdit",
                component: () => import("../views/financing/matter/Edit.vue"),
            },
            {
                path: "/delete-approval/index", // 删除审核列表
                name: "deleteApprovalIndex",
                component: () => import("../views/audit/delete/Index.vue"),
            },
            {
                path: "/repeat-claim/index", // 重复领取列表
                name: "repeatClaimIndex",
                component: () => import("../views/audit/repeat/Index.vue"),
            },
            {
                path: "/recommend-business/index", // 支行推荐业务列表
                name: "recommendBusinessIndex",
                component: () => import("../views/audit/recommend/Index.vue"),
            },
            {
                path: "/bank-product/index", // 银行产品列表
                name: "bankProductIndex",
                component: () => import("../views/audit/bank-product/Index.vue"),
            },
            {
                path: "/bankProduct/edit", // 银行产品编辑
                name: "bankProductEdit",
                component: () => import("../views/audit/bank-product/Edit.vue"),
            },
            {
                path: "/bank-product/up-index", // 银企快车产品列表
                name: "bankProductUpIndex",
                component: () => import("../views/audit/bank-product/UpIndex.vue"),
            },
            {
                path: "/bankProduct/apply", // 银企快车产品申请
                name: "bankProductApply",
                component: () => import("../views/audit/bank-product/Apply.vue"),
            },
            {
                path: "/bankProduct/application", // 银企快车产品授信申请
                name: "bankProductApplication",
                component: () => import("../views/audit/bank-product/Application.vue"),
            },
            {
                path: "/feedback/index", // 反馈信息列表
                name: "feedbackIndex",
                component: () => import("../views/feedback/Index.vue"),
            },
            {
                path: "/feedback/receive", // 反馈信息列表
                name: "feedbackReceive",
                component: () => import("../views/feedback/Receive.vue"),
            },
            {
                path: "/feedback/edit", // 反馈信息编辑
                name: "feedbackEdit",
                component: () => import("../views/feedback/Edit.vue"),
            },
            {
                path: "/notice/index", // 系统通知列表
                name: "systemNoticeIndex",
                component: () => import("../views/system-notice/Index.vue"),
            },
            {
                path: "/notice/edit", // 系统通知编辑
                name: "systemNoticeEdit",
                component: () => import("../views/system-notice/Edit.vue"),
            },
            {
                path: "/user/user-info", // 用户-基本信息
                name: "userIndex",
                component: () => import("../views/user/Index.vue"),
            },
            {
                path: "/changepwd", // 用户-修改密码
                name: "ChangePassword",
                component: () => import("../views/user/ChangePassword.vue"),
            },
            {
                path: '/setting/menu/index', // 系统设置-菜单管理
                name: 'MenuSettingIndex',
                component: () => import("../views/setting/MenuSetting.vue"),
            }
        ]
    },
    // {
    //     path: "/about",
    //     name: "about",
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    // },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/Login.vue"),
    },
];
const router = createRouter({
    // history: createWebHistory(process.env.BASE_URL),
    history: createWebHistory('/'),
    // mode: history,
    routes,
});
export default router;
